import { apiSlice } from "../../app/api/apiSlice"
import { blobExcelOption } from "../../app/services/base"
import { generateFormatedURL } from "../../utils/urlFormatter"

export const errorLogApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getErrorLog: builder.query<any, any>({
            query: (args) => "/ErrorLog/GetError".concat(generateFormatedURL(args)),
        }),

        getErrorExcel: builder.mutation({
            query: (body) => ({
                ...blobExcelOption,
                url: '/ErrorLog/GetExcel',
                // responseHandler: 'json',
                method: 'POST',
                body:  body,
                headers: {
                    'Content-Type': 'application/json'
                },
                responseType: 'blob' 
                
            })
        }),


    })
})

export const {
    useLazyGetErrorLogQuery,
    useGetErrorExcelMutation,
} = errorLogApiSlice  